module.exports = {"130408100":"临洺关镇","130408101":"大北汪镇","130408102":"张西堡镇","130408103":"广府镇","130408105":"永合会镇","130408106":"刘营镇","130408107":"西苏镇","130408108":"讲武镇","130408109":"东杨庄镇","130408201":"界河店乡","130408203":"刘汉乡","130408204":"正西乡","130408206":"曲陌乡","130408207":"辛庄堡乡","130408208":"小龙马乡","130408211":"西河庄乡","130408213":"西阳城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130408.json
// module id = 199
// module chunks = 0